// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-portfolio {
  min-height: 100vh;
  background: #000;
  color: #fff;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;
}

/* Hero Section */
.hero-section {
  min-height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4rem 2rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.hero-content {
  max-width: 900px;
  text-align: center;
}

.hero-title {
  font-size: clamp(2rem, 5vw, 3.5rem);
  font-weight: 700;
  margin-bottom: 1.5rem;
  line-height: 1.2;
}

.hero-subtitle {
  font-size: clamp(1rem, 2.5vw, 1.25rem);
  opacity: 0.95;
  line-height: 1.6;
  max-width: 700px;
  margin: 0 auto;
}

/* Projects Section */
.projects-section {
  padding: 4rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.projects-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 2rem;
}

/* Content Card */
.content-card {
  border-radius: 20px;
  padding: 2rem;
  color: #fff;
  background: rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(10px);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.content-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.4);
}

/* Card Header */
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
  gap: 1rem;
}

.project-info {
  flex: 1 1;
}

.project-name {
  font-size: 1.75rem;
  font-weight: 700;
  margin: 0 0 0.25rem 0;
}

.project-platform {
  font-size: 0.875rem;
  opacity: 0.8;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.profile-link {
  color: #fff;
  text-decoration: none;
  font-size: 0.875rem;
  padding: 0.5rem 1rem;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  transition: background 0.3s ease;
  white-space: nowrap;
}

.profile-link:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* Description */
.short-description {
  font-size: 1rem;
  line-height: 1.6;
  margin-bottom: 1rem;
  opacity: 0.95;
}

/* Stats Badge */
.stats-badge {
  display: inline-block;
  padding: 0.5rem 1rem;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 20px;
  font-size: 0.875rem;
  margin-bottom: 1.5rem;
  backdrop-filter: blur(10px);
}

/* Thumbnails Grid */
.thumbnails-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 0.75rem;
  margin-bottom: 1.5rem;
}

.thumbnail-link {
  display: block;
  text-decoration: none;
  color: inherit;
}

.thumbnail-placeholder {
  aspect-ratio: 9 / 16;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  transition: all 0.3s ease;
  cursor: pointer;
  border: 2px solid rgba(255, 255, 255, 0.1);
  padding: 1rem;
}

.thumbnail-placeholder:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.3);
  transform: scale(1.05);
}

.instagram-logo {
  width: 3rem;
  height: 3rem;
  opacity: 0.9;
}

.play-icon {
  font-size: 1.5rem;
  opacity: 0.9;
}

.thumbnail-placeholder:hover .play-icon {
  transform: scale(1.1);
}

.thumbnail-text {
  font-size: 0.75rem;
  opacity: 0.8;
  text-align: center;
}

/* Read More Button */
.read-more-btn {
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 25px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  backdrop-filter: blur(10px);
}

.read-more-btn:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-2px);
}

/* Full Description */
.full-description {
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  line-height: 1.7;
}

.full-description p {
  margin-bottom: 1rem;
  opacity: 0.9;
}

.full-description p:last-child {
  margin-bottom: 0;
}

/* CTA Section */
.cta-section {
  padding: 4rem 2rem;
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.cta-content {
  max-width: 700px;
  margin: 0 auto;
  text-align: center;
}

.cta-title {
  font-size: clamp(1.75rem, 4vw, 2.5rem);
  font-weight: 700;
  margin-bottom: 1rem;
}

.cta-text {
  font-size: clamp(1rem, 2vw, 1.125rem);
  line-height: 1.6;
  margin-bottom: 2rem;
  opacity: 0.95;
}

.cta-button {
  display: inline-block;
  padding: 1rem 2.5rem;
  background: #fff;
  color: #f5576c;
  text-decoration: none;
  font-weight: 700;
  border-radius: 30px;
  transition: all 0.3s ease;
  font-size: 1.125rem;
}

.cta-button:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
}

/* Responsive */
@media (max-width: 768px) {
  .projects-container {
    grid-template-columns: 1fr;
  }
  
  .card-header {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .profile-link {
    align-self: flex-start;
  }
  
  .hero-section {
    min-height: 40vh;
    padding: 3rem 1.5rem;
  }
  
  .projects-section {
    padding: 3rem 1.5rem;
  }
  
  .cta-section {
    padding: 3rem 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ContentPortfolio.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,iHAAiH;AACnH;;AAEA,iBAAiB;AACjB;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,8BAA8B;EAC9B,2BAA2B;EAC3B,0CAA0C;EAC1C,qDAAqD;EACrD,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,oCAAoC;EACpC,mBAAmB;EACnB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,oBAAoB;EACpB,qCAAqC;EACrC,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,oCAAoC;EACpC,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":[".content-portfolio {\n  min-height: 100vh;\n  background: #000;\n  color: #fff;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', sans-serif;\n}\n\n/* Hero Section */\n.hero-section {\n  min-height: 50vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 4rem 2rem;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.hero-content {\n  max-width: 900px;\n  text-align: center;\n}\n\n.hero-title {\n  font-size: clamp(2rem, 5vw, 3.5rem);\n  font-weight: 700;\n  margin-bottom: 1.5rem;\n  line-height: 1.2;\n}\n\n.hero-subtitle {\n  font-size: clamp(1rem, 2.5vw, 1.25rem);\n  opacity: 0.95;\n  line-height: 1.6;\n  max-width: 700px;\n  margin: 0 auto;\n}\n\n/* Projects Section */\n.projects-section {\n  padding: 4rem 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.projects-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));\n  gap: 2rem;\n}\n\n/* Content Card */\n.content-card {\n  border-radius: 20px;\n  padding: 2rem;\n  color: #fff;\n  background: rgba(0, 0, 0, 0.7);\n  backdrop-filter: blur(10px);\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.content-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 15px 50px rgba(0, 0, 0, 0.4);\n}\n\n/* Card Header */\n.card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 1rem;\n  gap: 1rem;\n}\n\n.project-info {\n  flex: 1;\n}\n\n.project-name {\n  font-size: 1.75rem;\n  font-weight: 700;\n  margin: 0 0 0.25rem 0;\n}\n\n.project-platform {\n  font-size: 0.875rem;\n  opacity: 0.8;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.profile-link {\n  color: #fff;\n  text-decoration: none;\n  font-size: 0.875rem;\n  padding: 0.5rem 1rem;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 20px;\n  transition: background 0.3s ease;\n  white-space: nowrap;\n}\n\n.profile-link:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n/* Description */\n.short-description {\n  font-size: 1rem;\n  line-height: 1.6;\n  margin-bottom: 1rem;\n  opacity: 0.95;\n}\n\n/* Stats Badge */\n.stats-badge {\n  display: inline-block;\n  padding: 0.5rem 1rem;\n  background: rgba(255, 255, 255, 0.15);\n  border-radius: 20px;\n  font-size: 0.875rem;\n  margin-bottom: 1.5rem;\n  backdrop-filter: blur(10px);\n}\n\n/* Thumbnails Grid */\n.thumbnails-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n  gap: 0.75rem;\n  margin-bottom: 1.5rem;\n}\n\n.thumbnail-link {\n  display: block;\n  text-decoration: none;\n  color: inherit;\n}\n\n.thumbnail-placeholder {\n  aspect-ratio: 9 / 16;\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 12px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  border: 2px solid rgba(255, 255, 255, 0.1);\n  padding: 1rem;\n}\n\n.thumbnail-placeholder:hover {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: rgba(255, 255, 255, 0.3);\n  transform: scale(1.05);\n}\n\n.instagram-logo {\n  width: 3rem;\n  height: 3rem;\n  opacity: 0.9;\n}\n\n.play-icon {\n  font-size: 1.5rem;\n  opacity: 0.9;\n}\n\n.thumbnail-placeholder:hover .play-icon {\n  transform: scale(1.1);\n}\n\n.thumbnail-text {\n  font-size: 0.75rem;\n  opacity: 0.8;\n  text-align: center;\n}\n\n/* Read More Button */\n.read-more-btn {\n  background: rgba(255, 255, 255, 0.2);\n  color: #fff;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 25px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  width: 100%;\n  backdrop-filter: blur(10px);\n}\n\n.read-more-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: translateY(-2px);\n}\n\n/* Full Description */\n.full-description {\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.2);\n  line-height: 1.7;\n}\n\n.full-description p {\n  margin-bottom: 1rem;\n  opacity: 0.9;\n}\n\n.full-description p:last-child {\n  margin-bottom: 0;\n}\n\n/* CTA Section */\n.cta-section {\n  padding: 4rem 2rem;\n  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n}\n\n.cta-content {\n  max-width: 700px;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.cta-title {\n  font-size: clamp(1.75rem, 4vw, 2.5rem);\n  font-weight: 700;\n  margin-bottom: 1rem;\n}\n\n.cta-text {\n  font-size: clamp(1rem, 2vw, 1.125rem);\n  line-height: 1.6;\n  margin-bottom: 2rem;\n  opacity: 0.95;\n}\n\n.cta-button {\n  display: inline-block;\n  padding: 1rem 2.5rem;\n  background: #fff;\n  color: #f5576c;\n  text-decoration: none;\n  font-weight: 700;\n  border-radius: 30px;\n  transition: all 0.3s ease;\n  font-size: 1.125rem;\n}\n\n.cta-button:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .projects-container {\n    grid-template-columns: 1fr;\n  }\n  \n  .card-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .profile-link {\n    align-self: flex-start;\n  }\n  \n  .hero-section {\n    min-height: 40vh;\n    padding: 3rem 1.5rem;\n  }\n  \n  .projects-section {\n    padding: 3rem 1.5rem;\n  }\n  \n  .cta-section {\n    padding: 3rem 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
